// src/components/navigation/BottomNavigation.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Home,         // Today 使用 Home 圖示
  CalendarDays,   // Calendar: 日曆含日期，比空白日曆更有辨識度
  User,     // Profile: 圓形用戶圖標，更現代化的設計
  FilePen,
  ListChecks,      // Tasks: 勾選清單，比單一勾選圖標更能表達「清單」概念
} from '../common/icons';

interface BottomNavigationProps {
  currentPage: string;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ currentPage }) => {
  // 使用圖標庫，圖標尺寸調整到 24px 以適應文字
  const navItems = [
    { path: '/today', label: 'Today', icon: <Home size={24} /> },
    { path: '/captures', label: 'Captures', icon: <FilePen size={24} /> },
    { path: '/tasks', label: 'Tasks', icon: <ListChecks size={24} /> },
    { path: '/calendar', label: 'Calendar', icon: <CalendarDays size={24} /> },
    { path: '/profile', label: 'My', icon: <User size={24} /> }
  ];

  return (
    <div className="bg-gradient-to-r from-sky-50 to-sky-50 border-t border-[#D1E5FF] flex justify-around items-center h-16 px-2">
      {navItems.map(item => (
        <NavItem
          key={item.path}
          to={item.path}
          label={item.label}
          isActive={currentPage === item.path.slice(1)}
          icon={item.icon}
        />
      ))}
    </div>
  );
};

interface NavItemProps {
  to: string;
  label: string;
  icon: React.ReactNode;
  isActive: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ to, label, icon, isActive }) => {
  return (
    <Link 
      to={to} 
      aria-label={label}
      className={`flex flex-col items-center justify-center p-1 min-h-[58px] min-w-[60px] transition-transform duration-200 active:scale-95 ${
        isActive 
          ? 'text-sky-600' 
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      {React.cloneElement(icon as React.ReactElement, { 
        color: isActive ? '#2563EB' : '#6B7280' 
      })}
      <span className={`text-xs mt-1 font-medium ${
        isActive ? 'text-sky-600' : 'text-gray-500'
      }`}>
        {label}
      </span>
    </Link>
  );
};

export default BottomNavigation;